import { render } from "./Vehicle.vue?vue&type=template&id=5d0cd4d0&scoped=true"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"

import "./Vehicle.vue?vue&type=style&index=0&id=5d0cd4d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0cd4d0"]])

export default __exports__